import loadable from '@loadable/component';

export const IdealhomeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "idealhome-site" */ './IdealhomeSiteWrapper'),
);
